import { 
  USER_ROLES, 
  ENROLLMENTS_SCHEDULE_TYPES, 
  APPOINTMENT_STATUS_TYPES, 
  SCHEDULE_EVENT_TYPES, 
  ENROLLMENT_STATUS_TYPES,
  SIGNING_TYPE 
} from './constants';

// Establish all environment variables here and assign default, if not available
export const ENV = import.meta.env.VITE_ENV || 'prod';
export const DEAFULT_API_VERSION = 'v1';
export const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:8100').replace(/\/$/, '');
export const PORT = import.meta.env.VITE_PORT || '8100';
export const API_PROXY = import.meta.env.VITE_API_PROXY || 'localhost:3333';
export const FEDERAL_DOCUMENT_ENTITY_TYPE = 1;
export const STATE_DOCUMENT_ENTITY_TYPE = 2;
export const PROGRAM_DOCUMENT_ENTITY_TYPE = 3;
export const IMAGECAPTURE_DOCUMENT_ENTITY_TYPE = 4;
export const MISCELLANEOUS_DOCUMENT_ENTITY_TYPE = 5;
export const GOOGLE_MAP_KEY = import.meta.env.VITE_GOOGLE_MAP_KEY;
export const RAPID_API_KEY = import.meta.env.VITE_RAPID_API_KEY;
export const RAPID_API_HOST = import.meta.env.VITE_RAPID_API_HOST;
export const GENESYS_API_KEY = import.meta.env.VITE_GENESYS_API_KEY;

export default {
  ENV,
  API_URL,
  DEAFULT_API_VERSION,
  FEDERAL_DOCUMENT_ENTITY_TYPE,
  STATE_DOCUMENT_ENTITY_TYPE,
  PROGRAM_DOCUMENT_ENTITY_TYPE,
  IMAGECAPTURE_DOCUMENT_ENTITY_TYPE,
  MISCELLANEOUS_DOCUMENT_ENTITY_TYPE,
  GOOGLE_MAP_KEY,
  ENROLLMENTS_SCHEDULE_TYPES,
  APPOINTMENT_STATUS_TYPES,
  SCHEDULE_EVENT_TYPES,
  ENROLLMENT_STATUS_TYPES,
  USER_ROLES,
  SIGNING_TYPE
};
